var alignment_default = {
  "alignLeft": "MN-Bj",
  "textWrapNowrap": "oqLF7",
  "alignRight": "zvwdg",
  "alignCenter": "_9Scyd",
  "sizeFullWidth": "sexcf",
  "renderedInTable": "ShWZI",
  "sizeOriginal": "XL8hY",
  "sizeContent": "CAKvR",
  "sizeSmall": "_0Rfa7",
  "sizeSmallCenter": "rluAx",
  "flex": "dz2WD",
  "LEFT": "rHGk5",
  "CENTER": "Lyk5M",
  "RIGHT": "_8NePu",
  "AUTO": "KVAVd",
  "JUSTIFY": "_-7vPo"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
